(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/authenticate/assets/javascripts/authenticate.js') >= 0) return;  svs.modules.push('/components/accountservices/authenticate/assets/javascripts/authenticate.js');

'use strict';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  LoginMethods,
  Events,
  Source,
  TimeoutTypes,
  FrejaStatus,
  BankidStatus,
  ErrorTypes,
  CONFIG,
  LoginTokenTTL
} = svs.accountservices.authenticate.definitions;
const {
  isSameProcessType,
  createNewProcess
} = svs.accountservices.authenticate.utils.process;
const logger = svs.core.log.getLogger('accountservices:authenticate');
const bankidErrorCodeLogger = svs.core.log.getLogger('accountservices:authenticate:bankid-error-codes');
const frejaErrorCodeLogger = svs.core.log.getLogger('accountservices:authenticate:freja-error-codes');
class Authenticate {
  constructor() {
    _defineProperty(this, "activeProcess", void 0);
    _defineProperty(this, "nextProcess", void 0);
    _defineProperty(this, "doNotSupportPageReload", void 0);
    _defineProperty(this, "errorRetries", CONFIG.ERROR_RETRIES);
    _defineProperty(this, "noActiveProcess", () => typeof this.activeProcess === 'undefined');
  }
  start() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const newProcess = createNewProcess(options);
    this.doNotSupportPageReload = options.doNotSupportPageReload || false;
    this.isIam = options.isIam || false;
    if (this.activeProcess) {
      if (this.activeProcess.loginToken || !this.activeProcess.loginToken && !isSameProcessType(this.nextProcess || this.activeProcess, newProcess)) {
        this.nextProcess = newProcess;
        if (!this.activeProcess.cancelled) {
          this.cancel();
        }
      }
    } else {
      if (options.loginToken && options.timeoutType && options.tokenTimestamp) {
        if (svs.accountservices.authenticate.utils.token.loginTokenIsHealthy(options.timeoutType, options.tokenTimestamp)) {
          this.activeProcess = newProcess;
          return this.triggerAsync(Events.READY_TO_POLL, this.activeProcess);
        }
        delete options.loginToken;
        delete options.timeoutType;
        delete options.tokenTimestamp;
      }
      this.activeProcess = newProcess;
      if (this.activeProcess.qr) {
        this.getLoginTokenFrameID = requestAnimationFrame(() => {
          delete this.getLoginTokenFrameID;
          this.getLoginToken();
        });
      } else {
        this.getLoginToken();
      }
    }
  }
  sign() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      options.isSign = true;
      this.start(options);
    } else {
      this.triggerAsync(Events.ERROR, {
        type: ErrorTypes.NOT_LOGGED_IN,
        message: 'Du måste vara inloggad.'
      });
    }
  }
  resetState() {
    if (this.pollingTimeoutId) {
      clearTimeout(this.pollingTimeoutId);
      delete this.pollingTimeoutId;
    }
    if (this.animationFrameID) {
      cancelAnimationFrame(this.animationFrameID);
      delete this.animationFrameID;
    }
    delete this.activeProcess;
  }
  resumePending() {
    let isIam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.isIam = isIam;
    svs.utils.url.refreshQueryString();
    const {
      lt: loginToken,
      ltt: timeoutType,
      ts: loginTokenTs,
      lis: isSignParam,
      lcm: codeChallengeMethod,
      lcc: codeChallenge,
      lm,
      nnc: nonce,
      cid: clientId
    } = svs.utils.url.queryString;
    if (loginToken && timeoutType && loginTokenTs && svs.accountservices.authenticate.utils.token.loginTokenIsHealthy(timeoutType, loginTokenTs)) {
      const method = lm === 'f' ? LoginMethods.FREJA : LoginMethods.BANKID;
      const isSign = isSignParam === 't';
      this.activeProcess = createNewProcess({
        loginToken,
        timeoutType,
        loginTokenTs,
        method,
        isSign,
        codeChallengeMethod,
        codeChallenge,
        nonce,
        clientId
      });
      return this.triggerAsync(Events.READY_TO_POLL, this.activeProcess);
    }
    this.triggerAsync(Events.NO_RESUME);
    this.clearUrlParams();
  }
  clearUrlParams() {
    svs.utils.url.refreshQueryString();
    if (this.isIam) {
      const queryData = {};
      queryData.lt = null;
      queryData.ltt = null;
      queryData.ts = null;
      queryData.lis = null;
      queryData.lcm = null;
      queryData.lcc = null;
      queryData.lm = null;
      queryData.nnc = null;
      queryData.cid = null;
      queryData.iif = null;
      this.trigger(Events.UPDATE_PARENT_URL, {
        queryData,
        clearUrlParams: true
      });
    }
    const {
      lt: currentLt,
      ltt: currentLtt,
      ts: currentTs,
      lis: currentLis,
      lcc: currentLcc,
      lcm: currentLcm,
      lm: currentLm
    } = svs.utils.url.queryString;
    if (currentLt || currentLtt || currentTs || currentLm || currentLis || currentLcc || currentLcm) {
      let delim = '?';
      let targetString = '';
      for (const param in svs.utils.url.queryString) {
        if (param !== 'lt' && param !== 'ltt' && param !== 'ts' && param !== 'lm' && param !== 'lcc' && param !== 'lcm' && param !== 'lis') {
          targetString = "".concat(targetString).concat(delim).concat(param, "=").concat(encodeURIComponent(svs.utils.url.queryString[param]));
          delim = '&';
        }
      }
      window.history.replaceState({}, '', "".concat(window.location.pathname).concat(targetString));
      svs.utils.url.refreshQueryString();
    }
  }
  setUrlParameters() {
    var _this$activeProcess4;
    if (this.noActiveProcess()) {
      return;
    }
    svs.utils.url.refreshQueryString();
    if (this.isIam) {
      var _this$activeProcess, _this$activeProcess2, _this$activeProcess3;
      const queryData = {};
      queryData.lt = this.activeProcess.loginToken;
      queryData.ltt = this.activeProcess.timeoutType;
      queryData.ts = this.activeProcess.loginTokenTs;
      queryData.lis = this.activeProcess.isSign ? 't' : 'f';
      queryData.lcm = this.activeProcess.codeChallengeMethod;
      queryData.lcc = this.activeProcess.codeChallenge;
      queryData.lm = (_this$activeProcess = this.activeProcess) !== null && _this$activeProcess !== void 0 && _this$activeProcess.isBankID ? 'b' : 'f';
      queryData.nnc = (_this$activeProcess2 = this.activeProcess) === null || _this$activeProcess2 === void 0 ? void 0 : _this$activeProcess2.nonce;
      queryData.cid = (_this$activeProcess3 = this.activeProcess) === null || _this$activeProcess3 === void 0 ? void 0 : _this$activeProcess3.clientId;
      queryData.iif = 1;
      this.trigger(Events.UPDATE_PARENT_URL, {
        queryData
      });
    }
    let targetPath = svs.utils.url.currentPathEncodedParams();
    targetPath = svs.utils.url.updateQueryStringParameter(targetPath, 'lm', (_this$activeProcess4 = this.activeProcess) !== null && _this$activeProcess4 !== void 0 && _this$activeProcess4.isBankID ? 'b' : 'f');
    targetPath = svs.utils.url.updateQueryStringParameter(targetPath, 'lis', this.activeProcess.isSign ? 't' : 'f');
    targetPath = svs.utils.url.updateQueryStringParameter(targetPath, 'lt', this.activeProcess.loginToken);
    targetPath = svs.utils.url.updateQueryStringParameter(targetPath, 'ltt', this.activeProcess.timeoutType);
    targetPath = svs.utils.url.updateQueryStringParameter(targetPath, 'ts', this.activeProcess.loginTokenTs);
    if (this.activeProcess.codeChallenge) {
      targetPath = svs.utils.url.updateQueryStringParameter(targetPath, 'lcc', this.activeProcess.codeChallenge);
      targetPath = svs.utils.url.updateQueryStringParameter(targetPath, 'lcm', this.activeProcess.codeChallengeMethod);
    }
    window.history.replaceState({}, '', targetPath);
  }
  serializeActiveProcess() {
    const {
      processID = '',
      loginToken = '',
      loginTokenTs = '',
      timeoutType = ''
    } = this.activeProcess;
    return "".concat(processID, ",").concat(loginToken, ",").concat(loginTokenTs, ",").concat(timeoutType);
  }
  poll() {
    if (!this.activeProcess || !this.activeProcess.loginToken) {
      this.trigger(Events.NOT_STARTED);
    } else if (this.isPolling()) {
      this.trigger(Events.ALREADY_POLLING);
    } else {
      if (!this.activeProcess.isBankID) {
        this.frejaPollStartTime = Date.now();
      }
      this.doPoll(CONFIG.INITIAL_POLL_DELAY);
    }
  }
  pause() {
    if (!this.activeProcess || !this.activeProcess.loginToken) {
      this.trigger(Events.NOT_STARTED);
    } else if (this.pollingTimeoutId || this.animationFrameID) {
      if (this.pollingTimeoutId) {
        clearTimeout(this.pollingTimeoutId);
        delete this.pollingTimeoutId;
      }
      if (this.animationFrameID) {
        cancelAnimationFrame(this.animationFrameID);
        delete this.animationFrameID;
      }
    } else {
      this.trigger(Events.NOT_POLLING);
    }
  }
  resume() {
    if (!this.activeProcess || !this.activeProcess.loginToken) {
      this.trigger(Events.NOT_STARTED);
    } else if (this.isPolling()) {
      this.trigger(Events.ALREADY_POLLING);
    } else {
      this.poll();
    }
  }
  listenTo() {
    if (arguments.length < 3 && typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'object') {
      const obj = arguments.length <= 0 ? undefined : arguments[0];
      const context = arguments.length <= 1 ? undefined : arguments[1];
      Object.keys(obj).forEach(key => {
        this.on(key, obj[key], context);
      });
    } else {
      this.on(...arguments);
    }
  }
  stopListeningTo() {
    if (arguments.length < 3 && typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'object') {
      const obj = arguments.length <= 0 ? undefined : arguments[0];
      Object.keys(obj).forEach(key => {
        this.off(key, obj[key]);
      });
    } else {
      this.off(...arguments);
    }
  }
  cancel() {
    if (this.noActiveProcess()) {
      return;
    }
    if (!this.activeProcess.cancelInProgress) {
      if (this.isPolling()) {
        this.pause();
        this.cancelToken();
      } else if (this.activeProcess.loginToken) {
        this.cancelToken();
      } else if (this.getLoginTokenFrameID) {
        cancelAnimationFrame(this.getLoginTokenFrameID);
        this.clearActiveProcess();
      }
    }
  }
  getAppUrl(iamAppReturnUrl) {
    var _this$activeProcess5;
    if (!this.activeProcess) {
      logger.warn('activeProcess missing for verification');
      return false;
    }
    const isBankID = (_this$activeProcess5 = this.activeProcess) === null || _this$activeProcess5 === void 0 ? void 0 : _this$activeProcess5.isBankID;
    let appUrl = '';
    if (this.activeProcess.loginToken) {
      if (isBankID) {
        appUrl = svs.accountservices.authenticate.utils.url.getBankIDAppUrl(this.activeProcess.loginToken, this.activeProcess.qr, iamAppReturnUrl);
      } else {
        appUrl = svs.accountservices.authenticate.utils.url.getFrejaEidAppUrl(this.activeProcess.loginToken, iamAppReturnUrl);
      }
    }
    return appUrl;
  }
  startedWithSsn() {
    if (this.noActiveProcess()) {
      return false;
    }
    return Boolean(this.activeProcess.ssn) || this.timeoutType === TimeoutTypes.BANKID_SSN;
  }
  isStarted() {
    return Boolean(this.activeProcess && this.activeProcess.loginToken);
  }
  isPolling() {
    return this.activeProcess && this.activeProcess.loginToken && Boolean(this.pollingTimeoutId || this.animationFrameID);
  }
  clearActiveProcess() {
    var _this$activeProcess6;
    if (this.noActiveProcess()) {
      return;
    }
    const isBankID = (_this$activeProcess6 = this.activeProcess) === null || _this$activeProcess6 === void 0 ? void 0 : _this$activeProcess6.isBankID;
    this.clearUrlParams();
    delete this.activeProcess;
    this.trigger(Events.CANCELLED, {
      isBankID
    });
    if (this.nextProcess) {
      this.activeProcess = this.nextProcess;
      delete this.nextProcess;
      this.getLoginToken();
    }
  }
  doPoll() {
    let timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CONFIG.POLL_INTERVAL;
    if (this.noActiveProcess()) {
      return;
    }
    this.animationFrameID = requestAnimationFrame(() => {
      delete this.animationFrameID;
      this.pollingTimeoutStart = new Date().getTime();
      this.pollingTimeoutId = setTimeout(() => {
        const delta = new Date().getTime() - this.pollingTimeoutStart;
        delete this.pollingTimeoutId;
        if (delta > CONFIG.POLL_INTERVAL + CONFIG.POLLING_DELTA_CUTOFF) {
          this.doPoll(CONFIG.INITIAL_POLL_DELAY);
        } else {
          this.callAuthenticateAPI();
        }
      }, timeout);
    });
  }
  pollingFinished() {
    this.clearActiveProcess();
  }
  triggerAsync(event, data) {
    return setTimeout(() => this.trigger(event, data), 30);
  }
  handleRetry(errorCode) {
    var _this$activeProcess7;
    if (this.noActiveProcess()) {
      return;
    }
    const isBankID = (_this$activeProcess7 = this.activeProcess) === null || _this$activeProcess7 === void 0 ? void 0 : _this$activeProcess7.isBankID;
    if (this.activeProcess.remainingRetries) {
      if (isBankID) {
        bankidErrorCodeLogger.info('56_retry');
      } else {
        frejaErrorCodeLogger.info("".concat(errorCode, "_retry"));
      }
      this.activeProcess.remainingRetries === 1 && this.trigger(Events.ONE_RETRY_LEFT);
      this.activeProcess.remainingRetries--;
      delete this.activeProcess.loginToken;
      this.activeProcess.autoPoll = true;
      this.getLoginToken();
    } else {
      if (isBankID) {
        bankidErrorCodeLogger.info('56_retryend');
      } else {
        frejaErrorCodeLogger.info("".concat(errorCode, "_retryend"));
      }
      this.pollingFinished();
      this.trigger(Events.RETRIES_FINISHED);
    }
  }
  getTokenAPIUrl() {
    var _this$activeProcess8;
    const isBankID = (_this$activeProcess8 = this.activeProcess) === null || _this$activeProcess8 === void 0 ? void 0 : _this$activeProcess8.isBankID;
    if (this.activeProcess && this.activeProcess.isSign) {
      if (isBankID) {
        return '/player/1/authenticatesign';
      }
      return '/player/1/frejaeid/initauthsign';
    }
    if (isBankID) {
      return '/player/1/authenticate';
    }
    return '/player/1/frejaeid/initauth';
  }
  getAuthenticateAPIUrl() {
    var _this$activeProcess9;
    const isBankID = (_this$activeProcess9 = this.activeProcess) === null || _this$activeProcess9 === void 0 ? void 0 : _this$activeProcess9.isBankID;
    if (this.activeProcess && this.activeProcess.isSign) {
      if (isBankID) {
        return '/player/1/authenticatesign/verify';
      }
      return '/player/1/frejaeid/initauthsign/verify';
    }
    if (isBankID) {
      return '/player/1/authenticate/login';
    }
    return '/player/1/frejaeid/getauthresult/login';
  }
  getLoginToken() {
    var _this$activeProcess0;
    if (this.noActiveProcess()) {
      return;
    }
    const isBankID = (_this$activeProcess0 = this.activeProcess) === null || _this$activeProcess0 === void 0 ? void 0 : _this$activeProcess0.isBankID;
    const opt = {
      method: 'POST',
      path: this.getTokenAPIUrl(),
      data: {}
    };
    if (this.activeProcess.codeChallenge && this.activeProcess.codeChallengeMethod) {
      opt.data = {
        codeChallenge: this.activeProcess.codeChallenge,
        codeChallengeMethod: this.activeProcess.codeChallengeMethod
      };
    }
    if (this.activeProcess.isCustomerRegistration) {
      opt.data.newCustomer = true;
    }
    if (isBankID && this.activeProcess.ssn) {
      opt.data.personalId = this.activeProcess.ssn;
    }
    if (this.activeProcess.nonce && this.activeProcess.clientId) {
      opt.data.nonce = this.activeProcess.nonce;
      opt.data.clientId = this.activeProcess.clientId;
    }
    svs.core.jupiter.call(opt, response => this.activeProcess && this.getLoginTokenSuccess(response), xhr => this.activeProcess && this.getLoginTokenError(xhr));
  }
  getLoginTokenSuccess(response) {
    var _this$activeProcess1;
    if (this.noActiveProcess()) {
      return;
    }
    const isBankID = (_this$activeProcess1 = this.activeProcess) === null || _this$activeProcess1 === void 0 ? void 0 : _this$activeProcess1.isBankID;
    this.activeProcess.loginToken = isBankID ? response.autoStartToken : response.authRef;
    if (this.activeProcess.cancelled) {
      this.cancelToken();
    } else {
      this.activeProcess.loginTokenTs = new Date().getTime();
      if (isBankID) {
        this.activeProcess.autoStartToken = response.autoStartToken;
        this.activeProcess.qrData = response.qrData;
        if (this.activeProcess.ssn) {
          this.activeProcess.timeoutType = TimeoutTypes.BANKID_SSN;
        } else if (!this.activeProcess.qr && svs.core.detect.os.iOS()) {
          this.activeProcess.timeoutType = TimeoutTypes.BANKID_IOS;
        } else {
          this.activeProcess.timeoutType = TimeoutTypes.BANKID;
        }
      } else {
        this.activeProcess.loginToken = response.authRef;
        this.activeProcess.timeoutType = TimeoutTypes.FREJA;
      }
      !this.doNotSupportPageReload && this.setUrlParameters();
      if (this.activeProcess.autoPoll) {
        delete this.activeProcess.autoPoll;
        this.trigger(Events.RETRY, this.activeProcess);
        this.doPoll();
      } else {
        this.trigger(Events.READY_TO_POLL, this.activeProcess);
      }
    }
  }
  getLoginTokenError(xhr) {
    var _xhr$responseJSON;
    const errorCode = (_xhr$responseJSON = xhr.responseJSON) === null || _xhr$responseJSON === void 0 || (_xhr$responseJSON = _xhr$responseJSON.error) === null || _xhr$responseJSON === void 0 ? void 0 : _xhr$responseJSON.code;
    if (!this.activeProcess.cancelled) {
      this.trigger(Events.ERROR, {
        type: ErrorTypes.CANNOT_GET_TOKEN,
        message: 'Det går inte att logga in just nu, var vänlig försök igen lite senare.',
        xhr
      });
    }
    if (errorCode !== 666 && errorCode !== 408) {
      var _this$activeProcess10, _xhr$responseJSON2;
      logger.error("Error starting ".concat((_this$activeProcess10 = this.activeProcess) !== null && _this$activeProcess10 !== void 0 && _this$activeProcess10.isBankID ? 'bankid' : 'freja', " login errorcode ").concat(errorCode, " calling ").concat(this.getTokenAPIUrl(), " : ").concat(JSON.stringify(xhr === null || xhr === void 0 || (_xhr$responseJSON2 = xhr.responseJSON) === null || _xhr$responseJSON2 === void 0 ? void 0 : _xhr$responseJSON2.error), " "));
    }
    this.clearActiveProcess();
  }
  cancelToken() {
    var _this$activeProcess11;
    if (this.noActiveProcess()) {
      return;
    }
    if ((_this$activeProcess11 = this.activeProcess) !== null && _this$activeProcess11 !== void 0 && _this$activeProcess11.loginToken && !this.activeProcess.completed) {
      const timeNow = new Date().getTime();
      if (timeNow - this.activeProcess.loginTokenTs < LoginTokenTTL[this.activeProcess.timeoutType] - CONFIG.CANCEL_CUTOFF) {
        var _this$activeProcess12;
        const isBankID = (_this$activeProcess12 = this.activeProcess) === null || _this$activeProcess12 === void 0 ? void 0 : _this$activeProcess12.isBankID;
        this.activeProcess.cancelInProgress = true;
        svs.core.jupiter.call({
          path: isBankID ? '/player/1/cancel' : '/player/1/frejaeid/cancelauth',
          method: 'POST',
          data: {
            [isBankID ? 'autoStartToken' : 'authRef']: this.activeProcess.loginToken
          }
        }, () => this.activeProcess && this.clearActiveProcess(), (xhr, status, err) => {
          if (this.activeProcess) {
            const errorCode = xhr && xhr.responseJSON && xhr.responseJSON.error && xhr.responseJSON.error.code;
            this.trigger(Events.ERROR, {
              type: ErrorTypes.CANNOT_CANCEL,
              message: 'Kan inte avbryta inloggningen',
              xhr
            });
            logger.info("Error aborting ".concat(isBankID ? 'bankid' : 'freja', " login errorcode ").concat(errorCode), err);
            this.clearActiveProcess();
          }
        });
      } else {
        logger.info("Cancel token called but loginToken is too old ".concat(timeNow - this.activeProcess.loginTokenTs));
        this.clearActiveProcess();
      }
    } else {
      logger.info('Cancel token called without a loginToken set');
    }
  }
  callAuthenticateAPI() {
    var _this$activeProcess13, _this$activeProcess14, _this$activeProcess15, _this$activeProcess16, _this$activeProcess17;
    if (this.noActiveProcess()) {
      return;
    }
    const isBankID = (_this$activeProcess13 = this.activeProcess) === null || _this$activeProcess13 === void 0 ? void 0 : _this$activeProcess13.isBankID;
    logger.debug("".concat(isBankID ? 'bankid' : 'freja', " loginToken: ").concat((_this$activeProcess14 = this.activeProcess) === null || _this$activeProcess14 === void 0 ? void 0 : _this$activeProcess14.loginToken));
    this.errorRetries = CONFIG.ERROR_RETRIES;
    this.activeProcess.completed = false;

    if (!((_this$activeProcess15 = this.activeProcess) !== null && _this$activeProcess15 !== void 0 && _this$activeProcess15.isBankID) && this.frejaPollStartTime && Date.now() - this.frejaPollStartTime >= LoginTokenTTL[this.activeProcess.timeoutType]) {
      this.handleRetry();
      this.frejaPollStartTime = Date.now();
      return;
    }
    let source = Source[svs.core.data.capabilities.channel] || 1;
    if ((_this$activeProcess16 = this.activeProcess) !== null && _this$activeProcess16 !== void 0 && _this$activeProcess16.isPoker) {
      source = svs.core.data.capabilities.channel === 'web-desktop' ? Source['poker-desktop'] : Source['poker-mobile'];
    }
    svs.core.jupiter.call({
      method: 'POST',
      path: this.getAuthenticateAPIUrl(),
      context: this,
      data: {
        [isBankID ? 'autoStartToken' : 'authRef']: (_this$activeProcess17 = this.activeProcess) === null || _this$activeProcess17 === void 0 ? void 0 : _this$activeProcess17.loginToken,
        source
      }
    }, response => this.activeProcess && this.callAuthenticateAPISuccess(response), response => this.activeProcess && this.callAuthenticateAPIError(response));
  }
  updateTimeoutType() {
    if (this.noActiveProcess()) {
      return;
    }
    svs.utils.url.refreshQueryString();
    if (svs.utils.url.queryString.ltt && parseInt(svs.utils.url.queryString.ltt, 10) !== this.activeProcess.timeoutType) {
      window.history.replaceState({}, 'Logga in', svs.utils.url.currentPathEncodedParams().replace(/&ltt=./, "&ltt=".concat(this.activeProcess.timeoutType)));
    }
  }
  callAuthenticateAPISuccess(response) {
    var _this$activeProcess18;
    if (this.noActiveProcess()) {
      return;
    }
    const isBankID = (_this$activeProcess18 = this.activeProcess) === null || _this$activeProcess18 === void 0 ? void 0 : _this$activeProcess18.isBankID;
    const status = isBankID ? response.progressStatus : response.status;
    if (isBankID && (this.activeProcess.qr || !svs.core.detect.os.iOS()) &&
    !this.activeProcess.ssn && status === BankidStatus.DELIVERED_TO_MOBILE && this.activeProcess.pollStatus < BankidStatus.DELIVERED_TO_MOBILE) {
      this.activeProcess.timeoutType = TimeoutTypes.BANKID_SSN;
      this.triggerAsync(Events.TIMEOUT_TYPE_UPDATED, this.activeProcess);
      this.updateTimeoutType();
    }
    this.activeProcess.pollStatus = status;
    if (this.activeProcess.isSign) {
      this.handleAuthenticateSignResponse(response, status);
    } else {
      this.handleAuthenticateLoginResponse(response, status);
    }
  }
  handleAuthenticateLoginResponse(response, status) {
    var _this$activeProcess19;
    if (this.noActiveProcess()) {
      return;
    }
    if (response.session || status === FrejaStatus.frejasts_APPROVED) {
      this.activeProcess.completed = true;
      this.handleLoginSuccess(response);
      this.pollingFinished();
    } else if (status === BankidStatus.NEW_CUSTOMER || status === BankidStatus.NEW_RETAILER_CUSTOMER || status === BankidStatus.RETURNING_CUSTOMER) {
      this.activeProcess.completed = true;
      this.handleNewCustomer(response);
      this.pollingFinished();
    } else if ((_this$activeProcess19 = this.activeProcess) !== null && _this$activeProcess19 !== void 0 && _this$activeProcess19.isBankID) {
      response.qrData && this.trigger(Events.QR_UPDATE, response.qrData);
      this.handleBankIDPollStatus(status, response);
    } else {
      this.handleFrejaPollStatus(status, response);
    }
  }
  handleAuthenticateSignResponse(response, status) {
    var _this$activeProcess20;
    if (this.noActiveProcess()) {
      return;
    }
    if (response.postToken) {
      this.triggerAsync(Events.SIGN, {
        postToken: response.postToken
      });
    } else if ((_this$activeProcess20 = this.activeProcess) !== null && _this$activeProcess20 !== void 0 && _this$activeProcess20.isBankID) {
      this.handleBankIDPollStatus(status, response);
    } else {
      this.handleFrejaPollStatus(status, response);
    }
  }
  callAuthenticateAPIError(xhr) {
    var _this$activeProcess21;
    if (this.noActiveProcess()) {
      return;
    }
    const isBankID = (_this$activeProcess21 = this.activeProcess) === null || _this$activeProcess21 === void 0 ? void 0 : _this$activeProcess21.isBankID;
    const errorCode = xhr && xhr.responseJSON && xhr.responseJSON.error && xhr.responseJSON.error.code;
    if (errorCode && errorCode === 666 && this.errorRetries > 0) {
      this.errorRetries = this.errorRetries - 1;
      logger.info("Received network error, retrying ".concat(isBankID ? 'bankid' : 'freja', " ").concat(this.errorRetries, " left. Time elapsed: ").concat(new Date().getTime() - this.pollingTimeoutStart));
      if (isBankID) {
        bankidErrorCodeLogger.info('666_retry');
      } else {
        frejaErrorCodeLogger.info('666_retry');
      }
      this.doPoll();
    } else {
      this.activeProcess.completed = true;
      let err;
      if (isBankID) {
        if (errorCode === 56) {
          if (this.activeProcess.retryPoll) {
            return this.handleRetry();
          }
          bankidErrorCodeLogger.info('56_noretry');
        } else {
          bankidErrorCodeLogger.info(errorCode === 666 ? '666_retryend' : errorCode);
        }
        err = svs.accountservices.authenticate.utils.error.getBankIDError(errorCode, xhr, this.activeProcess.ltFrServerSide);
      } else {
        if (errorCode === 71) {
          if (this.activeProcess.retryPoll) {
            return this.handleRetry(71);
          }
          frejaErrorCodeLogger.info('71_noretry');
        } else {
          frejaErrorCodeLogger.info(errorCode === 666 ? '666_retryend' : errorCode);
        }
        err = svs.accountservices.authenticate.utils.error.getFrejaError(errorCode, xhr, this.activeProcess.ltFrServerSide);
      }
      svs.components.analytics.trackEvent({
        category: 'Users',
        action: 'Login Failure',
        opt_label: isBankID ? 'bankid' : 'freja',
        opt_value: errorCode || 666
      });
      this.pollingFinished();
      this.trigger(Events.ERROR, err);
    }
  }
  async handleLoginSuccess(loginSuccessResponse) {
    var _this$activeProcess22, _loginSuccessResponse;
    const isBankID = this === null || this === void 0 || (_this$activeProcess22 = this.activeProcess) === null || _this$activeProcess22 === void 0 ? void 0 : _this$activeProcess22.isBankID;
    const lastLoginTime = svs.accountservices.authenticate.utils.parseISOString(loginSuccessResponse.lastLoginTime) || new Date();
    const firstName = loginSuccessResponse === null || loginSuccessResponse === void 0 || (_loginSuccessResponse = loginSuccessResponse.session) === null || _loginSuccessResponse === void 0 ? void 0 : _loginSuccessResponse.firstName;
    const {
      code,
      jwt
    } = loginSuccessResponse;
    svs.core.deviceSession.set('lastLoginType', 'login', svs.accountservices.authenticate.utils.process.processHasLoginMethod(this.activeProcess));

    if (code || jwt) {
      this.afterAll(null, loginSuccessResponse, lastLoginTime, isBankID, null);
      return;
    }
    const getCustomizedSettings = () => {
      svs.core.jupiter.call({
        path: '/player/2/customizedsettings',
        method: 'Get'
      }, response => {
        var _response$customizedS;
        let userId = null;
        let hasTimeLimit = false;
        if (svs.accountservices.authenticate.data.isPnP && !((_response$customizedS = response.customizedSettings) !== null && _response$customizedS !== void 0 && (_response$customizedS = _response$customizedS.properties) !== null && _response$customizedS !== void 0 && (_response$customizedS = _response$customizedS.onlineFlags) !== null && _response$customizedS !== void 0 && _response$customizedS.hasLoggedInPnP)) {
          svs.accountservices.authenticate.isFirstPnp = true;
          this.setPnpFirstLogin();
        }
        if (response.customizedSettings && response.customizedSettings.properties) {
          svs.accountservices.utils.user.saveToSessionStorage(response.customizedSettings.properties);
          userId = response.customizedSettings.properties.accountName || null;
          const relevant = response.customizedSettings.properties.relevantContent || false;
          const personalizedConsent = new svs.components.analytics.customEvents.WebConsentChanged(relevant);
          hasTimeLimit = response.customizedSettings.properties.hasTimeLimit;
          personalizedConsent.track();
        }
        const afterFn = self => {
          svs.core.userSession.set('userId', userId, () => {
            if (hasTimeLimit) {
              svs.core.userSession.set('hasTimeLimit', hasTimeLimit, () => {
                self.afterAll(userId, loginSuccessResponse, lastLoginTime, isBankID, firstName);
              });
            } else {
              self.afterAll(userId, loginSuccessResponse, lastLoginTime, isBankID, firstName);
            }
          });
        };

        async function trackAdobeUser(self, _ref) {
          let {
            customizedSettings
          } = _ref;
          try {
            customizedSettings && (await svs.core.analytics.trackAdobeUser(customizedSettings.properties.accountName));
          } catch (error) {
            logger.info('Error trying to call svs.core.analytics.trackAdobeUser', error);
          }
          afterFn(self);
        }
        if (typeof Promise === 'function') {
          trackAdobeUser(this, response);
        } else {
          afterFn(this);
        }
      }, error => {
        logger.info('Error trying to get userId from customized settings', error);
        this.afterAll(null, loginSuccessResponse, lastLoginTime, isBankID, firstName);
      });
    };

    svs.core.userSession.set('lastLoginTime', lastLoginTime.getTime(), e => {
      getCustomizedSettings();
    });
  }
  afterAll(userId, response, lastLoginTime, isBankID, firstName) {
    const successEvent = {
      category: 'Users',
      action: 'Login Success',
      opt_label: isBankID ? 'bankid' : 'freja'
    };
    svs.components.analytics.trackEvent(successEvent, this);
    this.trigger(Events.LOGIN, {
      lastLoginTime: lastLoginTime.getTime(),
      firstName,
      response
    });
  }
  setPnpFirstLogin() {
    const setfirstLoginPnpSession = () => {
      svs.core.userSession.set('customerFirstSession', true, error => {
        if (error) {
          logger.warn('Error setting customerFirstSession to true', error);
        } else {
          logger.info('Set customerFirstSession to true');
        }
      });
    };
    svs.core.jupiter.call({
      method: 'PUT',
      path: '/player/1/onlineflag/hasLoggedInPnP'
    }, () => {
      setfirstLoginPnpSession();
    }, err => {
      logger.error('Unable to PUT to set flag hasLoggedInPnP at /player/1/onlineflag/hasLoggedInPnP', err);
      setfirstLoginPnpSession();
    });
  }
  async handleNewCustomer(res) {
    var _this$activeProcess23;
    const {
      personalId: ssn,
      progressStatus: bankidStatus,
      status: frejaStatus,
      firstName,
      lastName,
      postToken,
      jwt,
      code
    } = res;
    const newCustomerEvent = {
      category: 'Users',
      action: 'Customer Registration'
    };
    let method;
    let labelExtra;
    let progressStatus;
    if (this !== null && this !== void 0 && (_this$activeProcess23 = this.activeProcess) !== null && _this$activeProcess23 !== void 0 && _this$activeProcess23.isBankID) {
      progressStatus = bankidStatus;
      method = 'bankid';
      labelExtra = '_bankid';
    } else {
      progressStatus = frejaStatus;
      method = 'freja';
      labelExtra = '_freja';
    }
    let customerType;
    if (progressStatus === 20) {
      newCustomerEvent.opt_label = "started_new_customer".concat(labelExtra);
      customerType = "new".concat(labelExtra);
    } else {
      newCustomerEvent.opt_label = "started_retail_customer".concat(labelExtra);
      customerType = "retail".concat(labelExtra);
    }
    svs.components.analytics.trackEvent(newCustomerEvent, () => {
      svs.components.Storage.browser.set('customerType', 'customer_registration', customerType, svs.components.Storage.constants.EXPIRES_1H, () => this.trigger(Events.NEW_CUSTOMER, {
        ssn,
        firstName,
        lastName,
        progressStatus,
        postToken,
        method,
        jwt,
        iamCode: code
      }));
    });
  }
  handleBankIDPollStatus(status, xhr) {
    if (this.noActiveProcess()) {
      return;
    }
    if (status) {
      this.doPoll();
    } else {
      this.activeProcess.completed = true;
      this.pollingFinished();
      svs.components.analytics.trackEvent({
        category: 'Users',
        action: 'Login Failure',
        opt_label: 'bankid',
        opt_value: '666'
      });
      this.trigger(Events.ERROR, {
        type: ErrorTypes.UNHANDLED,
        message: 'Det går inte att logga in just nu, var vänlig försök igen lite senare.',
        xhr
      });
    }
  }
  handleFrejaPollStatus(status, xhr) {
    if (this.noActiveProcess()) {
      return;
    }
    let error;
    switch (status) {
      case FrejaStatus.CANCELED:
      case FrejaStatus.RP_CANCELED:
        error = {
          type: ErrorTypes.LOGIN_USER_ABORTED,
          message: 'Inloggningen avbruten, var vänlig försök igen.',
          xhr
        };
        break;
      case FrejaStatus.REJECTED:
        error = {
          type: ErrorTypes.MULTIPLE_LOGINS,
          message: 'Du har redan en pågående inloggning, vänta och försök igen.',
          xhr
        };
        break;
      default:
        error = undefined;
    }
    if (error) {
      this.activeProcess.completed = true;
      frejaErrorCodeLogger.info("s".concat(status));
      this.pollingFinished();
      this.trigger(Events.ERROR, error);
    } else if (status === FrejaStatus.EXPIRED) {
      if (this.activeProcess.retryPoll) {
        this.handleRetry("s".concat(status));
      } else {
        frejaErrorCodeLogger.info("s".concat(status, "_noretry"));
        this.trigger(Events.ERROR, {
          type: ErrorTypes.TOKEN_EXPIRED,
          message: 'Det har gått för lång tid, var vänlig försök igen.',
          xhr
        });
      }
    } else {
      this.doPoll();
    }
  }
}
svs.accountservices.authenticate.Authenticate = Authenticate;

 })(window);